import { useVerifyEmailMutation } from 'api/user-domain/user-domain';
import { enqueueSnackbar } from 'notistack';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const useVerifyEmailLink = () => {
  const { t } = useTranslation();
  const [triggerVerifyEmail, { isLoading, isSuccess }] =
    useVerifyEmailMutation();

  useEffect(() => {
    if (isSuccess) {
      enqueueSnackbar(t('page.customers.form.customer.verifyEmail.success'), {
        severity: 'success',
      });
    }
  }, [isSuccess, t]);

  return { triggerVerifyEmail, isLoading, isSuccess };
};
